import { render } from "./index.vue?vue&type=template&id=aa13a066&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=aa13a066&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-aa13a066"

export default script